"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPropertiesDetailApiToken = exports.getFavsApiToken = exports.getRecentlyViewApiToken = exports.addRecentlyViewApiToken = exports.addFavApiToken = exports.removeFavByPropertyIdsApiToken = void 0;
var Api_1 = require("@/api/remote/Api");
var itemToSavePropertyRequest_1 = require("@/transformers/itemToSavePropertyRequest");
var PropertyCompact_sample_1 = require("@/pages/search/states/PropertyCompact.sample");
exports.removeFavByPropertyIdsApiToken = function (propertyIds, languageCode, token) {
    if (process.env.DEV)
        return Promise.resolve({ data: { status: true } });
    return Api_1.api().request({
        method: 'DELETE',
        url: languageCode + "/api/property/deleteuserpropertybypropertyids",
        headers: {
            'X-XSRF-TOKEN': token,
        },
        data: {
            savedPropertyType: itemToSavePropertyRequest_1.SavedPropertyTypes.Favorite,
            propertyIds: propertyIds,
        },
    });
};
exports.addFavApiToken = function (requestBodies, languageCode, token) {
    if (process.env.DEV)
        return Promise.resolve({ data: { status: true } });
    return Api_1.api().request({
        method: 'POST',
        url: languageCode + "/api/property/saveuserproperties",
        headers: {
            'X-XSRF-TOKEN': token,
        },
        data: requestBodies,
    });
};
exports.addRecentlyViewApiToken = function (requestBodies, languageCode, token) {
    if (process.env.DEV)
        return Promise.resolve({ data: { status: true } });
    return Api_1.api().request({
        method: 'POST',
        url: languageCode + "/api/property/saveuserproperties",
        headers: {
            'X-XSRF-TOKEN': token,
        },
        data: requestBodies,
    });
};
exports.getRecentlyViewApiToken = function (currencyKey, languageCode, page, pageSize, token) {
    if (process.env.DEV)
        return Promise.resolve({ data: [] });
    var requestBody = {
        CurrencyType: currencyKey,
        SavedPropertyType: itemToSavePropertyRequest_1.SavedPropertyTypes.RecentlyViewed,
        SortByType: itemToSavePropertyRequest_1.SavedPropertySortTypes.CreatedDate,
        PageNumber: page,
        PageSize: pageSize,
    };
    return Api_1.api().request({
        method: 'POST',
        url: languageCode + "/api/property/getuserproperties",
        headers: {
            'X-XSRF-TOKEN': token,
        },
        data: requestBody,
    });
};
exports.getFavsApiToken = function (currencyKey, languageCode, page, pageSize, token) {
    if (process.env.DEV)
        return Promise.resolve({ data: [] });
    var requestBody = {
        CurrencyType: currencyKey,
        SavedPropertyType: itemToSavePropertyRequest_1.SavedPropertyTypes.Favorite,
        SortByType: itemToSavePropertyRequest_1.SavedPropertySortTypes.CreatedDate,
        PageNumber: page,
        PageSize: pageSize,
    };
    return Api_1.api().request({
        method: 'POST',
        url: languageCode + "/api/property/getuserproperties",
        headers: {
            'X-XSRF-TOKEN': token,
        },
        data: requestBody,
    });
};
exports.getPropertiesDetailApiToken = function (ids, currencyKey, languageCode, token) {
    if (process.env.DEV)
        return Promise.resolve({ data: [PropertyCompact_sample_1.samplePropertyCompact] });
    var requestBody = {
        CurrencyType: currencyKey,
        PropertyListingIds: ids,
    };
    return Api_1.api().request({
        method: 'POST',
        url: languageCode + "/api/property/getpropertiesbyids",
        headers: {
            'X-XSRF-TOKEN': token,
        },
        data: requestBody,
    });
};
